import Card from "@/components/Card";
import { Button } from "@/components/ui/button";
import { addYears, format } from "date-fns";
import { useTranslation } from "react-i18next";

interface Props {
  id: string;
  issuedAt?: Date | null;
}

function IssuedCertificateInfoCard({ id, issuedAt }: Props) {
  // const expiryAt = issuedAt ? new Date(issuedAt.getTime() + 1000 * 60 * 60 * 24 * 365) : null
  const expiryAt = issuedAt ? addYears(issuedAt, 1) : null;
  const { t } = useTranslation();
  return (
    <Card className="p-5 flex items-center justify-between">
      <div>
        <p className="text-base text-cool-gray-900 font-medium">
          {t("certificate-issued")}
        </p>
        <p className="text-sm text-cool-gray-600 font-normal flex flex-row mt-1">
          {t("certificate-issued-on")}
          <span className=" text-sm text-cool-gray-600 font-medium ml-1">
            {issuedAt ? format(issuedAt, t("date-format")) : "Not issued"}
          </span>
        </p>
        <p className="text-sm text-cool-gray-600 font-normal flex flex-row">
          {t("expiry")}
          <span className="text-sm text-cool-gray-600 font-medium ml-1">
            {expiryAt ? format(expiryAt, t("date-format")) : "--/--/--"}
          </span>
        </p>
      </div>
      <Button
        onClick={() => window.open(`/console/certificates/${id}`, "_blank")}
      >
        {t("download-certificate")}
      </Button>
    </Card>
  );
}

export default IssuedCertificateInfoCard;
